import ProdutoAdicionalService from "@/services/ProdutoAdicionalService";

export const produtoAdicional = {
  namespaced: true,
  state: {
    produtoAdicional: {},
  },
  actions: {
    getProdutoAdicional({ commit }, payload) {
      return ProdutoAdicionalService.GetProdutoAdicional(payload).then(
        (produtoAdicional) => {
          return Promise.resolve(produtoAdicional);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postProdutoAdicional({ commit }, payload) {
      return ProdutoAdicionalService.PostProdutoAdicional(payload).then(
        (produtoAdicional) => {
          return Promise.resolve(produtoAdicional);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putProdutoAdicional({ commit }, payload) {
      return ProdutoAdicionalService.PutProdutoAdicional(payload).then(
        (produtoAdicional) => {
          return Promise.resolve(produtoAdicional);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteProdutoAdicional({ commit }, payload) {
      return ProdutoAdicionalService.DeleteProdutoAdicional(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getProdutoAdicionalOData({ commit }, payload) {
      return ProdutoAdicionalService.GetProdutoAdicionalOData(payload).then(
        (produtoAdicional) => {
          return Promise.resolve(produtoAdicional);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default produtoAdicional;
